import { Button, Spacer, Text, Title } from 'internalLibrary';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classes from 'classnames';
import SentIcon from '../../../components/icons/SentIcon';
import styles from './InstructionsSent.module.scss';

const InstructionsSent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const loginClicked = () => {
    navigate('/login');
  };

  return (
    <div className={styles.content}>
      <div className={styles.main}>
        <Spacer marginBottom="30px" maxWidth="375px">
          <Title
            text={t('temporaryPasswordSent_title')}
            icon={<SentIcon />}
            forceColumn
          />
        </Spacer>

        <Spacer marginBottom="60px">
          <Text
            kind="span"
            level={2}
            text={t('temporaryPasswordSent_text')}
            className={styles.subtitle}
          />
        </Spacer>

        <Button
          onClick={loginClicked}
          className={classes(styles.center, styles.button)}
        >
          {t('temporaryPasswordSent_login')}
        </Button>
      </div>
    </div>
  );
};

export default InstructionsSent;
